import angular from 'angular'

import './init'
import './vend-ui/vend-ui'

/**
 * =======================================
 * Import modules
 * =======================================
 */

import './http/http'
import './resolvers/resolvers'
import './routes/routes'
import './filters/filters'
import './directives/directives'
import './components/components'
import './modals/modals'
import './factories/factories'
import './components/quick-keys/nodes/qk-nodes-resource'
// Managers (relationship between controller and business logic)
import './managers/managers'
import './controllers/controllers'
import './ng-compat/wrapper'
import './vendor-modules/vendor-modules'
import './util/feature-cache'

import './config'

import {
  initDatadog,
  initDatadogLogging,
  initQualtrics,
  isDevelopment,
} from '@vend/utilities'
import { UIRouter } from '@uirouter/angularjs'
import fauxQuickKeysTemplate from '../templates/current-sale/faux-quick-keys.html'
import customerSearchErrorTemplate from './components/customer/customer-error.html'
import loadingSkeletonTemplate from './components/loading-skeleton/loading-skeleton.html'
import spaLoadingSkeletonTemplate from './components/loading-skeleton/spa-loading-skeleton.html'
import productSearchErrorTemplate from './components/product/product-error.html'
import { $templateCache } from './ng-compat/imports'
import { InsufficientStateForOfflineError } from './constants'
import { persistStore } from './state/store'

declare global {
  interface Window {
    rg4js?: (option: string, value?: string) => void
  }
}

if ('rg4js' in window && window.rg4js && isDevelopment(window.location.href)) {
  window.rg4js('disableAutoBreadcrumbsConsole')
}

initDatadog({
  applicationName: 'webregister',
  clientToken: 'puba581fd000ecb6f18f1b632a6f865569d',
  applicationId: '47234048-0349-4fc0-92af-efa189f3031f',
})

initDatadogLogging({
  applicationName: 'webregister',
  clientToken: 'pub49d329122a0621a27c95f738aca44f90',
})

if (!isDevelopment(window.location.href)) {
  initQualtrics()
}

angular.module('webregister').run(function ($uiRouter: UIRouter) {
  // Preload the template cache with the few templates that we ng-include.
  $templateCache.put('current-sale/faux-quick-keys.html', fauxQuickKeysTemplate)
  $templateCache.put(
    'customer/customer-error.html',
    customerSearchErrorTemplate
  )
  $templateCache.put(
    'loading-skeleton/loading-skeleton.html',
    loadingSkeletonTemplate
  )
  $templateCache.put(
    'loading-skeleton/spa-loading-skeleton.html',
    spaLoadingSkeletonTemplate
  )
  $templateCache.put('product/product-error.html', productSearchErrorTemplate)

  // Enable persisting Redux store to IndexedDB.
  persistStore()

  // Ensure any errors that occur during routing aren't silently ignored. This at least causes the error to be logged
  // to the console
  $uiRouter.stateService.defaultErrorHandler((error: $TSFixMe) => {
    // InsufficientStateForOfflineError is handled upstream
    if (error.detail) {
      if (!(error.detail instanceof InsufficientStateForOfflineError)) {
        throw error
      }
    }
  })
})
